import { motion } from "framer-motion";

import DUMMY_DATA from "../../dummyData.json";
import classes from "./Product.module.css";
import ProductFilter from "./ProductFilter";
import { useEffect, useState } from "react";
import ProductList from "./ProductList";
import { useSearchParams, useLocation, useNavigate } from "react-router-dom";

const Product = ({ data, pageLimit, dataLimit }) => {
  const [filteredData, setFilteredData] = useState(DUMMY_DATA);
  const [currentPage, setCurrentPage] = useState(1);
  const navigate = useNavigate();
  const [pageUrl, setPageUrl] = useSearchParams({});
  const location = useLocation();
  const locationPage = location.search.slice(-1);

  useEffect(() => {
    // setPageUrl({ page: currentPage });
    // console.log(pageUrl.get("page"));
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [currentPage]);

  function changePage(event) {
    const pageNumber = Number(event.target.textContent);
    setCurrentPage(pageNumber);
  }

  const getPaginatedData = () => {
    const startIndex = currentPage * dataLimit - dataLimit;
    const endIndex = startIndex + dataLimit;
    return data.slice(startIndex, endIndex);
  };

  const getPaginationGroup = () => {
    let start = Math.floor((currentPage - 1) / pageLimit) * pageLimit;
    return new Array(pageLimit).fill().map((_, idx) => start + idx + 1);
  };

  const filterHandler = (filteredData) => {
    setFilteredData(filteredData);
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0, transition: { duration: "0.1" } }}
      className={classes.container}
    >
      <h2 className={classes.productTitle}>
        <span className={classes.highlight}>產品列表</span>
      </h2>
      <ProductFilter data={DUMMY_DATA} filterHandler={filterHandler} />
      <ul className={`${classes.product}`}>
        {getPaginatedData().map((data) => {
          return (
            <ProductList
              key={data.id}
              data={data}
              className={classes.product__item}
            />
          );
        })}
      </ul>
      <div className={classes.pagination}>
        {/* show page numbers */}
        {getPaginationGroup().map((item, index) => (
          <button
            key={index}
            onClick={changePage}
            className={`${classes.pagination__item} ${
              currentPage === item ? classes.pagination__active : null
            }`}
          >
            <span>{item}</span>
          </button>
        ))}
      </div>
    </motion.div>
  );
};

export default Product;
